// Canonical user-facing copy and message builders.
// Sentence case, no exclamation marks. See src/documentation/guides/CopyStyle.mdx.

// Generic fallback — use ONLY when no specific message is available.
export const GENERIC_ERROR = 'Something went wrong. Please try again.';

// Generic fallback with a support escalation — use when retrying alone may not resolve the issue.
export const GENERIC_ERROR_SUPPORT =
  'Something went wrong. Please try again. If the problem continues, contact support.';

// Permission denial — mirrors the backend's code-2 responses.
export const PERMISSION_DENIED = "You don't have permission to perform this action";

// Validation
export const EMAIL_INVALID = 'Enter a valid email address';
export const requiredMsg = (field) => `${field} is required`;

// Success builders — "{Thing} {past-tense verb}", no trailing period, no "!"
export const savedMsg = (thing = 'Changes') => `${thing} saved`;
export const createdMsg = (thing) => `${thing} created`;
export const updatedMsg = (thing) => `${thing} updated`;
export const deletedMsg = (thing) => `${thing} deleted`;

// Failure builder — "Couldn't {verb} {thing}"
export const failedMsg = (verb, thing) => `Couldn't ${verb} ${thing}`;
